const app = angular.module('msi.shipping.add', [
  'ui.router',
  require('@ordergroove/brandy/src/app/addresses'),
  require('@ordergroove/brandy/src/app/forms'),
  require('@ordergroove/brandy/src/app/toasts'),
  require('../modal')
]);

app.config(require('./state'));

module.exports = app.name;
